module.exports = __webpack_public_path__ + "img/Beach.867715bf.jpg";